module.exports = __webpack_public_path__ + "img/intec-logo.e5fc9f7c.png";